module.exports = {"522726001":"井城街道","522726108":"百泉镇","522726109":"影山镇","522726110":"基长镇","522726111":"下司镇","522726112":"麻尾镇","522726113":"麻万镇","522726114":"上司镇","522726115":"玉水镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522726.json
// module id = 2665
// module chunks = 0